import { ContactPathsEnum } from 'modules/contactPage/routes';
import { LeasingCalculatorPathsEnum } from 'modules/leasingCalculator/routes';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyledFooterLink,
  StyledFooterLinksContainer,
  StyledLinkList,
} from './styled';

export const FooterLinks: React.FC = () => {
  const { t } = useTranslation();

  return (
    <StyledFooterLinksContainer>
      <StyledLinkList>
        <li>
          <StyledFooterLink
            to={{
              pathname:
                '',
            }}
            target="_blank"
            aria-label={t('footer.termsAndConditions')}>
            <a aria-label={t('footer.termsAndConditions')} href='https://unicreditleasing.hr/home/footer/uvjeti-poslovanja' target='_blank'>{t('footer.termsAndConditions')}</a>
          </StyledFooterLink>
        </li>
        <li>
          <StyledFooterLink
            to={{ pathname: '' }}
            target="_blank"
            aria-label={t('footer.about')}>
            <a aria-label={t('footer.about')} href='https://unicreditleasing.hr/home/o-nama/o-nama' target='_blank'>{t('footer.about')}</a>
          </StyledFooterLink>
        </li>
        <li>
          <StyledFooterLink
              to={{
                pathname:
                    '',
              }}
              target="_blank"
            aria-label={t('footer.privacyProtection')}>
            <a aria-label={t('footer.privacyProtection')} href='https://unicreditleasing.hr/home/footer/izjava-o-zastiti-privatnosti-na-internetskim-stranicama-unicredit-leasing-croatia-doo' target='_blank'>{t('footer.privacyProtection')}</a>
          </StyledFooterLink>
        </li>
        <li>
          <StyledFooterLink
              aria-label={t('footer.leasingCalculator')}
              to={{pathname: LeasingCalculatorPathsEnum.leasingCalculator }}>
            {t('footer.leasingCalculator')}
          </StyledFooterLink>
        </li>
        <li>
          <StyledFooterLink aria-label={t('footer.support')} to={{ pathname: ContactPathsEnum.contactPage }}>
            {t('footer.support')}
          </StyledFooterLink>
        </li>
        <li>
          <StyledFooterLink
            aria-label={t('footer.faq')}
            to={{
              pathname:
                '',
            }}
            target="_blank">
            <a aria-label={t('footer.faq')} href='https://unicreditleasing.hr/home/o-leasingu/kljucna-pitanja' target='_blank'>{t('footer.faq')}</a>
            </StyledFooterLink>
        </li>
      </StyledLinkList>
    </StyledFooterLinksContainer>
  );
};
